/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { useAssetImages } from 'sarsaparilla';

import { HeroImageGallery } from './HeroImageGallery';
import type { HeroImageGalleryBaseProps } from './HeroImageGallery.types';

export interface HeroImageGalleryWithFetchProps extends HeroImageGalleryBaseProps {
    /** The id of the campground/permit/ticket facility/gateway/POI that the
     * api will use to fetch the images.
     * Do not use the images prop if using this prop.
     *
     * Inherited from the base props; also used to track the favorite icon. */
    assetId?: string;

    /** The id of the campsite that the api will use to fetch the images
     * Do not use the images if using this prop.
     */
    campsiteId?: string;

    /** The tour id the api will use to fetch the images
     * Do not use the images if using this prop.
     */
    tourId?: string;
}

export function HeroImageGalleryWithFetch({
    assetId,
    campsiteId,
    tourId,
    hasThumbnailStrip = true,
    className,
    imageLoadingStrategy,
    ...rest
}: HeroImageGalleryWithFetchProps) {
    const { heroImage, galleryImages, status } = useAssetImages({
        assetId,
        campsiteId,
        tourId,
    });

    return (
        <HeroImageGallery
            heroImage={heroImage}
            galleryImages={galleryImages}
            status={status}
            hasThumbnailStrip={hasThumbnailStrip}
            className={className}
            assetId={assetId}
            imageLoadingStrategy={imageLoadingStrategy}
            {...rest}
        />
    );
}
